module.exports = __webpack_public_path__ + "static/media/splash-remove.a6ddd306.svg";